import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Calculatrice de taille de soutien-gorge";
const DESCRIPTION =
  "Calculatrice de taille de soutien-gorge pour obtenir des estimations utiles en sante feminine et suivi du cycle. Entrez vos informations et recevez des resultats rapides pour mieux planifier.";
const KEYWORDS =
  "de taille de soutien gorge, calculatrice de taille de soutien gorge, calcul en ligne, sante feminine, cycle, grossesse, resultat rapide";
const OG_URL =
  "https://do-calculate.com/calculator/fr/bra-size-calculator/";
function BraSizeCalculator() {
  const [underBust, setUnderBust] = useState("");
  const [bustMeasure, setBustMeasure] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      if (!underBust || !bustMeasure) {
        setError("Veuillez entrer tous les paramètres");
        setResult(null);
        return;
      }
      const under = parseFloat(underBust);
      const bust = parseFloat(bustMeasure);
      const band = Math.round(under / 2.54);
      const cupDiff = bust - under;
      let cup = "";
      if (cupDiff < 2) cup = "AA";
      else if (cupDiff < 4) cup = "A";
      else if (cupDiff < 6) cup = "B";
      else if (cupDiff < 8) cup = "C";
      else if (cupDiff < 10) cup = "D";
      else if (cupDiff < 12) cup = "DD";
      else cup = "E+";
      setResult(`${band}${cup}`);
      setError("");
    } catch (err) {
      setError("Erreur lors du calcul");
      setResult(null);
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  La calculatrice de taille de soutien-gorge vous aide à trouver votre taille
                  exacte en cm. Mesurez votre tour de poitrine et votre tour sous les seins,
                  et nous calculerons votre taille de soutien-gorge.
                </p>
                <ul>
                  <li>Calcul facile et rapide</li>
                  <li>Mesures en centimètres</li>
                  <li>Résultats précis</li>
                </ul>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div>
                  <div>
                    <hr />
                    <div className="form-group">
                      <label className="form-label ms-2">
                        Tour sous les seins (cm)
                      </label>
                      <input
                        type="number"
                        value={underBust}
                        onChange={(e) => setUnderBust(e.target.value)}
                        placeholder="Mesure sous les seins"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2">
                        Tour de poitrine (cm)
                      </label>
                      <input
                        type="number"
                        value={bustMeasure}
                        onChange={(e) => setBustMeasure(e.target.value)}
                        placeholder="Mesure du tour de poitrine"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      Calculer                    </button>
                  </div>
                  <br />
                  {error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Erreur: {error}
                    </p>
                  )}
                  {result && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>Résultat:</h4>
                      <p>
                        Votre taille: <strong>{result}</strong>
                      </p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="col-12 col-md-8">
        <div className="info-sections-container">
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>Qu'est-ce qu'une taille de soutien-gorge?</h3>
            </div>
            <div className="info-section-body">
              <p>
                Une taille de soutien-gorge est une mesure composée d'un nombre et d'une lettre. Le nombre représente votre tour de poitrine sous la poitrine directement, et la lettre représente la taille de la coupe du soutien-gorge. La bonne taille est déterminée par les mesures de tour de poitrine et de taille de coupe.
              </p>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                Pourquoi est-il important de choisir la bonne taille de soutien-gorge?
              </h3>
            </div>
            <div className="info-section-body">
              <p>
                Choisir la bonne taille de soutien-gorge est très important pour la santé et le confort. Un soutien-gorge mal ajusté peut causer des douleurs au dos et au cou, affecter la circulation sanguine et causer une irritation de la peau. De plus, un soutien-gorge bien ajusté renforce la confiance en soi et vous donne une meilleure apparence.
              </p>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                Comment mesurer les dimensions de mon corps pour obtenir la bonne taille?
              </h3>
            </div>
            <div className="info-section-body">
              <p>Pour mesurer les dimensions de votre corps avec précision, suivez les étapes suivantes:</p>
              <ol>
                <li>Utilisez un ruban à mesurer flexible.</li>
                <li>Mesurez votre tour de poitrine directement sous la poitrine.</li>
                <li>Mesurez la partie la plus large de votre poitrine.</li>
                <li>Calculez la différence entre les deux mesures pour obtenir la taille de la coupe.</li>
              </ol>
              <p>
                Pour des résultats plus précis, vous pouvez vous référer au guide de mesure fourni avec la calculatrice ou rechercher des tutoriels vidéo.
              </p>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                Conseils pour choisir le soutien-gorge idéal
              </h3>
            </div>
            <div className="info-section-body">
              <p>
                En plus de choisir la bonne taille, voici quelques conseils pour choisir le soutien-gorge approprié:
              </p>
              <ul>
                <li>Essayez le soutien-gorge avant d'acheter.</li>
                <li>Choisissez un soutien-gorge fait de tissu naturel.</li>
                <li>Assurez-vous que les bretelles sont confortables et ne causent aucune pression.</li>
                <li>Faites attention à la conception de la coupe et assurez-vous qu'elle offre un soutien adéquat.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default BraSizeCalculator;
